import { render } from "./dineIn.vue?vue&type=template&id=09486d40&scoped=true"
import script from "./dineIn.vue?vue&type=script&lang=js"
export * from "./dineIn.vue?vue&type=script&lang=js"

import "./dineIn.vue?vue&type=style&index=0&id=09486d40&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09486d40"]])

export default __exports__